// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer-module--footer--2k5FJ","container":"Footer-module--container--WDQEF","icons":"Footer-module--icons--VaFuu","cv":"Footer-module--cv--3ykgi"};